import styled from "@emotion/styled";


export const RectangualarDotSection = styled.div`
widht: 100%;
heinght: 150px;
overflow: hidden;
`;